import React from "react";

export const MySales = () => {
  const fakeData = [
    {
      date: "2024-01-15",
      status: "Paid",
      product: "Product A",
      license: "ABC123",
      price: 49.99,
      net: 45.99
    },
    {
      date: "2024-01-16",
      status: "Processing",
      product: "Product B",
      license: "DEF456",
      price: 89.99,
      net: 80.99
    },
    {
      date: "2024-01-17",
      status: "Paid",
      product: "Product C",
      license: "GHI789",
      price: 29.99,
      net: 27.99
    },
    {
      date: "2024-01-18",
      status: "Processing",
      product: "Product D",
      license: "JKL012",
      price: 99.99,
      net: 90.99
    },
    {
      date: "2024-01-19",
      status: "Paid",
      product: "Product E",
      license: "MNO345",
      price: 59.99,
      net: 55.99
    },
    {
      date: "2024-01-20",
      status: "Processing",
      product: "Product F",
      license: "PQR678",
      price: 39.99,
      net: 35.99
    },
    {
      date: "2024-01-21",
      status: "Paid",
      product: "Product G",
      license: "STU901",
      price: 79.99,
      net: 75.99
    },
    {
      date: "2024-01-22",
      status: "Processing",
      product: "Product H",
      license: "VWX234",
      price: 109.99,
      net: 100.99
    },
    {
      date: "2024-01-23",
      status: "Paid",
      product: "Product I",
      license: "YZA567",
      price: 69.99,
      net: 65.99
    },
    {
      date: "2024-01-24",
      status: "Processing",
      product: "Product J",
      license: "BCD890",
      price: 49.99,
      net: 45.99
    }
  ];
  
  return (
    <div className="w-full  lg:px-6 lg:py-4 overflow-x-scroll lg:w-[90%] xl:w-full hidescroll">
  
      <h1 className="text-[28px] md:text-[32px]">My Orders ({fakeData.length})</h1>
      <div className="relative my-4 hidescroll px-2 rounded-lg border-[#F0F0F0] border-[2px] dark:border  dark:border-[#3d3d3d] overflow-x-auto md:min-w-[800px] py-2">
        <table className="w-full rounded-lg text-sm text-left rtl:text-right">
          <thead className="text-xs rounded-lg text-gray-700 uppercase dark:text-white dark:bg-[#2F2F2F] bg-[#F2F2F2]">
            <tr>
              <th scope="col" className="px-6 py-3">
                DATE
              </th>
              <th scope="col" className="px-6 py-3">
                STATUS
              </th>
              <th scope="col" className="px-6 py-3">
                PRODUCT
              </th>
              <th scope="col" className="px-6 py-3">
                LICENSE
              </th>
              <th scope="col" className="px-6 py-3">
                PRICE
              </th>
              <th scope="col" className="px-6 py-3">
                NET
              </th>
            </tr>
          </thead>
          <tbody>
            {fakeData.map((order, index) => (
              <tr key={index} className={index === 0 || index !== fakeData.length - 1 ? "bg-white border-b border-[#F0F0F0] dark:border-[#3D3D3D] dark:bg-transparent" : ''}>
              
                <td className="px-6 py-4">{order.date}</td>
                <td className="px-6 py-4">{order.status}</td>
                <td className="px-6 py-4">
                  <div className={`rounded-lg px-2 py-1 w-fit ${getStatusColor(order.status)}`}>
                    <p>{order.status}</p>
                  </div>
                </td>
                <td className="px-6 py-4">{order.license}</td>
                <td className="px-6 py-4">{order.price}</td>
                <td className="px-6 py-4">{order.net}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>  
    </div>
  );
};

const getStatusColor = (status) => {
  if (status === "Processing") return "bg-[#FFF2B1] text-[#5C4F09] dark:bg-[#5C4F09] dark:text-[#FFE55E] ";
  if (status === "Paid") return "bg-[#CBF0D0] text-[#1D6528] dark:bg-[#175220] dark:text-gray-200";
  return "";
};
